import { render, staticRenderFns } from "./DimensionsInputGroup.vue?vue&type=template&id=4024a4fa&scoped=true&"
import script from "./DimensionsInputGroup.vue?vue&type=script&lang=ts&"
export * from "./DimensionsInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./DimensionsInputGroup.vue?vue&type=style&index=0&id=4024a4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024a4fa",
  null
  
)

export default component.exports